import { Outlet, useNavigate, useLocation } from "react-router-dom";
import { AppBar, Toolbar, Typography, Button, Box, Container, IconButton } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useAuth } from "../auth/AuthContext";

const ROOT_PATHS = ["/doctor", "/admin", "/physician"];

export default function Layout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = () => {
    logout();
    navigate("/login");
  };

  const isAdmin = user?.role === "admin" || user?.is_superuser;
  // Production-роли (physician/test_administrator) и админ — английский UI
  const isEnglishUi =
    isAdmin || user?.role === "physician" || user?.role === "test_administrator";
  const isRootPage = ROOT_PATHS.includes(location.pathname);
  // Кабинет physician шире исследовательского (sm=600px было тесно для
  // когниметра и отчёта): md≈900px повторяет ширину карточки в референсе
  // CogNimbus/cognimeter/cognitive_gauge_v8.html (880px)
  const containerWidth = isAdmin ? "lg" : user?.role === "physician" || user?.role === "test_administrator" ? "md" : "sm";

  return (
    <Box sx={{ minHeight: "100vh", bgcolor: "#f5f5f5" }}>
      <AppBar position="static">
        <Toolbar>
          {!isRootPage && (
            <IconButton
              edge="start"
              color="inherit"
              onClick={() => navigate(-1)}
              sx={{ mr: 1 }}
            >
              <ArrowBackIcon />
            </IconButton>
          )}
          <Typography
            variant="h6"
            sx={{ flexGrow: 1, cursor: "pointer" }}
            onClick={() => navigate("/")}
          >
            SaccaScan
          </Typography>
          {user && (
            <>
              <Typography variant="body2" sx={{ mr: 2, display: { xs: "none", sm: "block" } }}>
                {user.name ? `${user.name} ${user.surname || ""}`.trim() : user.email}
              </Typography>
              <Button color="inherit" onClick={handleLogout}>
                {isEnglishUi ? "Logout" : "Выйти"}
              </Button>
            </>
          )}
        </Toolbar>
      </AppBar>
      <Container maxWidth={containerWidth} sx={{ py: 3 }}>
        <Outlet />
      </Container>
    </Box>
  );
}
